import {useEffect, useState} from "react";

export default function useWellId(wellName: string, assets) {
    const [wellEntity, setWellEntity] = useState(null)

    useEffect(() => {
        const well = assets.find(e => e.type === 'well' && e.name === wellName)
        if (well) {
            setWellEntity(well)
        }
    }, [wellName, assets])

    return wellEntity
}